var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6753 53.1713V58.8047",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4750_11481",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 88,
    height: 88
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H88V88H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4750_11481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6763 65.1686V70.8329C16.6763 71.6907 17.146 72.4798 17.9004 72.8885L42.8865 86.4264C43.5814 86.803 44.4193 86.803 45.1142 86.4264L70.1003 72.8885C70.8547 72.4798 71.3244 71.6907 71.3244 70.8329V53.5983",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.001 57.4204V85.8609",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0006 27.8109L16.6763 42.6157L44.0006 57.4204L71.325 42.6157L44.0006 27.8109Z",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2538 20.6375L44.001 27.8109L71.3251 42.6157L80.0172 32.6435C80.5091 32.0791 80.3512 31.2042 79.6929 30.8474L70.1102 25.6556",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5056 22.619L56.186 18.1114",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5871 23.1116L8.30905 30.8474C7.65077 31.204 7.49282 32.0791 7.98472 32.6435L16.6766 42.6157L44.001 27.8109L34.9648 17.4442C34.6052 17.0317 34.0076 16.924 33.5265 17.1845L28.3608 19.9834",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0023 57.4204L32.9795 61.1525C32.3633 61.3612 31.688 61.3036 31.1158 60.9937L7.04406 47.9515C6.1467 47.4654 6.25928 46.1437 7.22591 45.8165L16.678 42.6156L44.0023 57.4204Z",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7774 45.8164L71.3253 42.6156L44.001 57.4204L55.0238 61.1527C55.64 61.3612 56.3155 61.3036 56.8875 60.9937L80.9594 47.9515C81.8566 47.4654 81.744 46.1437 80.7774 45.8164Z",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2983 75.7281L54.2554 74.1259",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6852 5.99416L29.7354 9.94402",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6852 9.94406L29.7354 5.9942",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2256 18.5075C19.2256 15.9409 21.3061 13.8602 23.8727 13.8602C26.4395 13.8602 28.5201 15.9409 28.5201 18.5075C28.5201 21.0741 26.4395 23.1548 23.8727 23.1548C21.3061 23.1548 19.2256 21.0741 19.2256 18.5075Z",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8488 14.4384L67.8989 18.3883",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8488 18.3884L67.8989 14.4385",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0736 17.4447C56.0736 19.4835 54.4211 21.1363 52.3821 21.1363C50.3435 21.1363 48.6909 19.4835 48.6909 17.4447C48.6909 15.4061 50.3435 13.7534 52.3821 13.7534C54.4211 13.7534 56.0736 15.4061 56.0736 17.4447Z",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1982 5.61615C64.1982 8.0059 62.261 9.9431 59.8711 9.9431C57.4815 9.9431 55.5439 8.0059 55.5439 5.61615C55.5439 3.2264 57.4815 1.28902 59.8711 1.28902C62.261 1.28902 64.1982 3.2264 64.1982 5.61615Z",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8355 35.492C35.8554 36.8761 32.1982 41.4411 32.1982 46.8617C32.1982 48.5272 32.5437 50.1136 33.1676 51.5505L44.0009 57.42L54.8342 51.5505C55.4581 50.1136 55.8036 48.5272 55.8036 46.8617C55.8036 41.4532 52.1626 36.8966 47.1993 35.5015",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.347 50.3747C45.7212 49.8407 44.8434 49.5056 43.8682 49.5026C42.893 49.4997 42.0132 49.8296 41.3843 50.36",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6089 45.685H49.6216",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3823 45.685H38.3947",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6089 45.685H49.6213",
    stroke: "#A0A3B1",
    strokeWidth: 2.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox1);
export default __webpack_public_path__ + "static/media/box 1.c6bc43c3872666ed8fed3215df41b109.svg";
export { ForwardRef as ReactComponent };